import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function CheckPayuTransaction() {
  const [data, setData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { txnid } = e.target;
      let requestData = {
        txnid: txnid.value
      };
      const response = await axios.post("/checkPayuTransaction", requestData);
      const { status, result } = response.data;
      if (status) {
        setData(result);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Check PayU Transaction
              </h4>
              <form className="searchForm" onSubmit={handleSubmit}>
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <label for="txnid">Transaction Id</label>
                    <input class="form-control" type="number" name="txnid" required />
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  {
                    (data && (Object.entries(data).length > 0)) && (
                      <>
                        <ul className="showData">
                          <li>
                            <strong>PayU ID:</strong>
                            <div>{data.mihpayid}</div>
                          </li>
                          <li>
                            <strong>Transaction Amount:</strong>
                            <div>{data.transaction_amount}</div>
                          </li>
                          <li>
                            <strong>Transaction Id:</strong>
                            <div>{data.txnid}</div>
                          </li>
                          <li>
                            <strong>First Name:</strong>
                            <div>{data.firstname}</div>
                          </li>
                          <li>
                            <strong>Error Message:</strong>
                            <div>{data.error_Message}</div>
                          </li>
                          <li>
                            <strong>Mode:</strong>
                            <div>{data.mode}</div>
                          </li>
                          <li>
                            <strong>Status:</strong>
                            <div>{data.status}</div>
                          </li>
                        </ul>
                      </>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckPayuTransaction;
